import { Box, Container, Stack, Typography, Accordion, AccordionSummary, AccordionDetails } from '@mui/material'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import { SECTION_DARK } from '../theme'

interface FaqItem {
    q: string
    a: string
}

interface FaqSectionProps {
    title?: string
    subtitle: string
    items: FaqItem[]
    color: string
}

export function FaqSection({
    title = 'Common questions',
    subtitle,
    items,
    color,
}: FaqSectionProps) {
    return (
        <Box sx={{ ...SECTION_DARK }}>
            <Container maxWidth="md">
                <Typography variant="h2" sx={{ color: 'white', textAlign: 'center', mb: 2 }}>{title}</Typography>
                <Typography sx={{ color: 'rgba(255,255,255,0.5)', textAlign: 'center', mb: 6 }}>
                    {subtitle}
                </Typography>
                <Stack spacing={1.5}>
                    {items.map(faq => (
                        <Accordion key={faq.q} disableGutters elevation={0} sx={{
                            border: '1px solid rgba(0,0,0,0.08)',
                            borderRadius: '10px !important',
                            '&:before': { display: 'none' },
                            '&.Mui-expanded': { border: `1px solid ${color}40` },
                        }}>
                            <AccordionSummary expandIcon={<ExpandMoreIcon />} sx={{ px: 3, py: 0.5 }}>
                                <Typography sx={{ fontWeight: 600, fontSize: '15px' }}>{faq.q}</Typography>
                            </AccordionSummary>
                            <AccordionDetails sx={{ px: 3, pb: 2.5 }}>
                                <Typography color="text.secondary" sx={{ lineHeight: 1.7 }}>{faq.a}</Typography>
                            </AccordionDetails>
                        </Accordion>
                    ))}
                </Stack>
            </Container>
        </Box>
    )
}
